import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { enableFreeMode } from 'bookingform';

import { BOOKING_STEP, setStep } from '../../actions/Booking';
import { emptyShoppingCart } from '../../actions/Cart';
import { logout } from '../../actions/Loyalty';
import { initSession, loginUser } from '../../actions/Session';

import '../../static/less/user_login.less';
import withNavigate from '../../withNavigate'; // Importa el HOC

class LoginForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
      loginInvalid: false,
    };
    this.userLogin = this.userLogin.bind(this);
    this.updateUsername = this.updateUsername.bind(this);
    this.updatePassword = this.updatePassword.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(setStep(BOOKING_STEP.NO_AVAIL_STEP));
    if (!this.props.user.isAnonymous) {
      this.props.navigate('/');
    }
    if (!this.props.hasSession) {
      this.props.dispatch(initSession());
    }
  }

  updateUsername(ev) {
    this.setState({ username: ev.target.value });
  }

  updatePassword(ev) {
    this.setState({ password: ev.target.value });
  }

  userLogin() {
    const user = {
      username: this.state.username,
      password: this.state.password,
    };
    this.setState({ loginInvalid: false });
    this.props.dispatch(loginUser(user)).then((success) => {
      if (success) {
        this.props.dispatch(enableFreeMode(true));
        this.props.dispatch(emptyShoppingCart());
        if (this.props.loyaltyUser) {
          this.props.dispatch(logout());
        }
        this.props.navigate('/');
      } else {
        this.setState({ loginInvalid: true });
      }
    });
  }

  render() {
    return (
            <section className="LoginForm">
              <div className="form-group">
                <label htmlFor="login-username">{this.context.t('Username')}:</label>
                <input id="login-username" className="form-control" type="text" value={this.state.username}
                       onChange={this.updateUsername}/>
              </div>
              <div className="form-group">
                <label htmlFor="login-password">{this.context.t('Password')}:</label>
                <input id="login-password" className="form-control" type="password" value={this.state.password}
                       onChange={this.updatePassword}/>
              </div>
              <div className="LoginForm__actions mt-2">
                <button className="btn btn-primary login-button" onClick={this.userLogin}>
                  {this.context.t('Login')}
                </button>
                <span className="LoginForm__forgotten">
            <a href="/password/reset/">{this.context.t('Have you forgotten your password?')}</a>
          </span>
              </div>
              {this.state.loginInvalid && <div className="row">
                <div className="col-md-4 col-md-offset-3 error">Login invalid</div>
              </div>}
            </section>
    );
  }
}

LoginForm.propTypes = {
  navigate: PropTypes.func.isRequired, // Prop para `navigate`
};

LoginForm.contextTypes = {
  t: PropTypes.func.isRequired,
};

// Conectar el componente con Redux
const mapStateToProps = (state) => ({
  hasSession: state.bookingFormState.sessionId !== null,
  user: state.session.user || { isAnonymous: true },
  loyaltyUser: state.loyalty.loggedUser,
});

const ConnectedLoginForm = connect(mapStateToProps)(LoginForm);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedLoginForm);
